export { ChipComplete as default } from './ChipComplete';
